import React from "react";
// import ShowComment from "../commentHistory/ShowComment";
import FeedHistory from "./FeedHistory";
import FeedLabelHistory from "./FeedLabelHistory";
import FeedGitHistory from "./FeedGitHistory";
import ListFeedCard from "../feedCard/ListFeedCard";

const SIMPLE_HISTORY_TYPES = new Set([
  "Comment",
  "WorkLog",
  "Attachments",
  "Watchlist",
  "Title",
]);

const ListFeedHistory = ({ history, boardName }) => {
  if (SIMPLE_HISTORY_TYPES.has(history?.history_type)) {
    return <FeedHistory history={history} boardName={boardName} />;
  }

  if (history?.history_type === "Label" || history?.history_type === "Epic") {
    return <FeedLabelHistory history={history} boardName={boardName} />;
  }

  if (history?.history_type === "git_event") {
    return <FeedGitHistory history={history} />;
  }

  if (history?.history_type === "Card" || history?.history_type === "Custom Field") {
    return <ListFeedCard card={history} boardName={boardName} />;
  }

  return null;
};

export default React.memo(ListFeedHistory);
